import React from 'react';
import ProductItemTitles from '../Shared/ProductItemTitles';
import {isMobile} from 'react-device-detect';
import {ColumnHtml, ColumnTwoPartsHtml, ColumnHtmlWithIcon, DataUsageHtml} from '../Shared/sharedHtmlComponents';
import {productStatus} from '../productsAndServicesBlockSlice';
import ProductStatus from '../Shared/ProductStatus';
import CategoryName from '../Shared/CategoryName';
import {productsTypes} from '../productsAndServicesBlockSlice';

const CellularItem = (props) => {
  const itemTitles = ['מספר קו', 'חבילה', 'ניצול חבילת גלישה'];
  const widthList = ['20', '30', '50'];

  const goToUsageDataPage = async () => {
    props.context.navigateTo(props.dataUsageUrl);
  };
  return (
    <div className={`productAndServicesItemContainer ${props.type}`}>
      <CategoryName
        title={'סלולר'}
        imageName={`${isMobile ? 'mobile' : 'mobile-desc'}`}
        goToAction={props.goToAction}
        actions={props.cellularActions}
        allActionButtonText={props.allActionButtonText}
        goToAllAction={props.goToAllAction}
        type={productsTypes.CELLULAR}
      />

      {!isMobile && <ProductItemTitles titlesList={itemTitles} widthList={widthList} />}
      {props.cellularItems?.map((cellularItem, index) => {
        const subscriberNo = cellularItem.subscriberNumber;
        const ban = cellularItem.ban;
        const status =
          cellularItem.productStatus == productStatus.BUSINESS ||
          cellularItem.productStatus == productStatus.CANCELLED ||
          cellularItem.productStatus == productStatus.SUSPENDED
            ? cellularItem.productStatus
            : null;
        return (
          <div key={index}>
            {!isMobile ? (
              <div className='productAndServicesItemContainer_content_wrapper d-flex'>
                {status && <ProductStatus status={status} />}
                <ColumnHtml item={subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2')} columnWidth={widthList[0]} customClass={'semiBold'} />
                <ColumnHtmlWithIcon
                  item={cellularItem.packageName}
                  columnWidth={widthList[1]}
                  buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})}
                />
                {cellularItem.productStatus != productStatus.CANCELLED && (
                  <DataUsageHtml
                    item={cellularItem.cellularSurfingUseDetails}
                    buttonAction={goToUsageDataPage}
                    columnWidth={widthList[2]}
                    customClass={''}
                    alertAction={props.openDataUsageAlertPopup}
                    index={index}
                  />
                )}
              </div>
            ) : (
              <div className='productAndServicesItemContainer_content_wrapper'>
                <ColumnTwoPartsHtml
                  title={subscriberNo.replace(/^(.{3})(.*)$/, '$1-$2')}
                  titleCustomClass={'semiBold black'}
                  textCustomClass={'status'}>
                  {status && <ProductStatus status={status} />}
                </ColumnTwoPartsHtml>
                <ColumnTwoPartsHtml title={'חבילה'} titleCustomClass={'align-items-center'}>
                  <ColumnHtmlWithIcon item={cellularItem.packageName} buttonAction={() => props.getCurrentPricePlan({subscriberNo, ban})} />
                </ColumnTwoPartsHtml>
                {cellularItem.productStatus != productStatus.CANCELLED && (
                  <ColumnTwoPartsHtml title={'ניצול חבילת גלישה'}>
                    <DataUsageHtml
                      item={cellularItem.cellularSurfingUseDetails}
                      buttonAction={goToUsageDataPage}
                      alertAction={props.openDataUsageAlertPopup}
                    />
                  </ColumnTwoPartsHtml>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default CellularItem;
